import { Get } from '../http/httpVerbs';

export const apiGetCommunityCreators = async (communityId, query) => {
    try {
        const response = await Get(`${process.env.REACT_APP_API_URL}/comunidades/${communityId}/creators?query=${query}`);
        return response;
    } catch (error) {
        throw error;
    }
};
